/* eslint-disable import/prefer-default-export */
/**
 * Configuration constants for IncludedEntitlements component
 */

export const CONSTANTS = {
  // NestedListRowGroup configuration
  TALLEST_ROW_HEIGHT: 4, // rem - based on documentation
  AFTER_CONTENT_HEIGHT: -2,
} as const;

export const SCORE_CHIP_CONFIGS = {
  CONFIDENCE_THRESHOLDS: {
    HAPPY: 80,
    NEUTRAL: 60,
    // 0-59 uses Sad icon (implicit)
  },

  SCORE_ICONS: {
    HAPPY: 'Happy' as const,
    NEUTRAL: 'Neutral' as const,
    SAD: 'Sad' as const,
  },

  SCORE_COLORS: {
    HAPPY: 'success' as const,
    NEUTRAL: 'warning' as const,
    SAD: 'critical' as const,
  },

  SCORE_CLASSNAMES: {
    HAPPY: 'Rules-scoreChip--happy',
    NEUTRAL: 'Rules-scoreChip--neutral',
    SAD: 'Rules-scoreChip--sad',
  },
} as const;
